import EditorJS from '@editorjs/editorjs';
import ImageTool from '@editorjs/image';
import List from '@editorjs/list';
import Header from '@editorjs/header';

window.editorInstance = function(dataProperty, editorId, readOnly, placeholder, logLevel) {
    return {
        instance: null,
        data: null,

        initEditor() {
            this.data = this.$wire.get(dataProperty);

            this.instance = new EditorJS({
                holder: editorId,

                readOnly,

                placeholder: "Start typing...",

                logLevel,

                tools: {
                    image: {
                        class: ImageTool,

                        config: {
                            buttonContent: 'Select Image or Video',
                            types: 'image/*,video/*',
                            uploader: {
                                uploadByFile: (file) => {
                                    return new Promise((resolve) => {
                                        this.$wire.upload(
                                            'uploads',
                                            file,
                                            (uploadedFilename) => {
                                                const eventName = `fileupload:${uploadedFilename.substr(0, 20)}`;

                                                const storeListener = (event) => {
                                                    resolve({
                                                        success: 1,
                                                        file: {
                                                            url: event.detail.url
                                                        }
                                                    });

                                                    window.removeEventListener(eventName, storeListener);
                                                };

                                                window.addEventListener(eventName, storeListener);

                                                this.$wire.call('completedImageUpload', uploadedFilename, eventName);
                                            }
                                        );
                                    });
                                },

                                uploadByUrl: (url) => {
                                    return this.$wire.loadImageFromUrl(url).then(result => {
                                        return {
                                            success: 1,
                                            file: {
                                                url: result
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    },
                          list: {
                          class: List,
                          inlineToolbar: true,
                          config: {
                            defaultStyle: 'unordered'
                          }
                        },
                    header: Header,

                },

                data: this.data,

                                i18n: {
                    messages: {
                      ui: {
                        // Translations of internal UI components of the editor.js core
                      },
                      toolNames: {
                        "Image": "Media",
                      },
                      tools: {
                      },
                      blockTunes: {
                      },
                    }
                  },

                onChange: () => {
                    this.instance.save().then((outputData) => {
                        this.$wire.set(dataProperty, outputData);

                        this.$wire.call('save');
                    }).catch((error) => {
                        console.log('Saving failed: ', error)
                    });
                },

                  onReady: () => {
                    if ($('video').length > 0) {
                        $("video").each(function(){
                           $(this).attr("controls", true).attr("autoplay", false);
                        })
                    }
               }
            });
        }
    }
}
